import React, { Component } from 'react'

export class TodoDetails extends Component {
    render() {

        const { id, body, details } = this.props.todo;

        return (
            <div className="todo-details-container">
                <h5>Details About <strong>{body}</strong></h5>
                <p>{details == "" ? "Has No Details" : details}</p>
            </div>
        )
    }
}

export default TodoDetails
